import $ from 'jquery';
import matchHeight from 'jquery-match-height';

$(window).on("load", function (e) {
  $(".js-match-height-title").matchHeight();
  $(".js-match-height-text").matchHeight();
})